import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { NavigationTypeEnum } from '@/shared/constant/navigation/Navigation';
import { findSelectedNavbarFolderItem } from '@/shared/util/findSelectedNavbarFolderItem';
import React from 'react';

export function useGenerateBreadcrumbList() {
  const navigation = useDocsDataModelStore((x) => x.navigation);
  const parentSidebarTreeApiFolderNodes = useDocsDataModelStore(
    (x) => x.sidebarTree.parentSidebarTreeApiFolderNodes,
  );

  const list = React.useMemo(() => {
    const result: {
      key: string;
      name: string;
    }[] = [];

    if (
      navigation.type === NavigationTypeEnum.FirstLevelNavigation ||
      navigation.type === NavigationTypeEnum.SecondLevelNavigation ||
      navigation.type === NavigationTypeEnum.ThirdLevelNavigation
    ) {
      const selectedNavbarItem = findSelectedNavbarFolderItem(navigation.firstLevelNavbarItems);
      if (selectedNavbarItem) {
        result.push({
          key: selectedNavbarItem.id,
          name: selectedNavbarItem.title,
        });
      }
    }
    if (
      navigation.type === NavigationTypeEnum.SecondLevelNavigation ||
      navigation.type === NavigationTypeEnum.ThirdLevelNavigation
    ) {
      const selectedNavbarItem = findSelectedNavbarFolderItem(navigation.secondLevelNavbarItems);
      if (selectedNavbarItem) {
        result.push({
          key: selectedNavbarItem.id,
          name: selectedNavbarItem.title,
        });
      }
    }
    if (navigation.type === NavigationTypeEnum.ThirdLevelNavigation) {
      const selectedNavbarItem = findSelectedNavbarFolderItem(navigation.thirdLevelNavbarItems);
      if (selectedNavbarItem) {
        result.push({
          key: selectedNavbarItem.id,
          name: selectedNavbarItem.title,
        });
      }
    }

    result.push(
      ...parentSidebarTreeApiFolderNodes.map((x) => {
        return {
          key: x.key,
          name: x.name,
        };
      }),
    );
    const lastItem = result[result.length - 1];
    if (!lastItem) {
      return [];
    }

    return [lastItem];
  }, [navigation, parentSidebarTreeApiFolderNodes]);

  return list;
}
